export default __webpack_public_path__ + "static/media/schedule.4260a1cb.svg";